<template>
  <div
    class="article-head__other-field article-head__other-field__calendar"
    v-if="openingInfo"
    >{{ openingInfo }}</div
  >
</template>
<script>
export default {
  props: {
    openingInfo: {
      type: String,
      default: '',
    },
  }
}
</script>